import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function AuthPage() {
  const [text2, setText2] = React.useState("");
  const [text, setText] = React.useState("");
  const [showPassword, setshowPassword] = React.useState(false);
  const [showPasswordConfirm, setshowPasswordConfirm] = React.useState(false);

  const onchange = (e) => {
    setText(e.target.value);
  };
  const onchange2 = (e) => {
    setText2(e.target.value);
  };

  const { t } = useTranslation();
  return (
    <div className="phone-form">
      <h1 className="auth__title">{t("auth.recreate.title")} </h1>
      <h3 className="auth__subtitle">{t("auth.recreate.sub")}</h3>

      <div className="auth__box">
        <div className="form__group ">
          <div className="row row--no-padding">
            <div className=" col-padding-small pos-rel">
              <input
                onChange={onchange}
                value={text}
                type={showPassword ? "text" : "password"}
                className={`form__input has-icon has-left-icon circle ${
                  text.length < 1 ? "" : text !== text2 ? "error" : "success"
                }`}
                placeholder={t("placeholders.passord")}
              />
              <img
                src={`${process.env.PUBLIC_URL}/img/lock.svg`}
                alt="cobon back"
                className="form__icon"
              />
              {showPassword ? (
                <img
                  src={`${process.env.PUBLIC_URL}/img/eye_2.svg`}
                  alt="cobon back"
                  onClick={() => setshowPassword(!showPassword)}
                  className="form__icon--left"
                />
              ) : (
                <img
                  src={`${process.env.PUBLIC_URL}/img/eye.svg`}
                  alt="cobon back"
                  onClick={() => setshowPassword(!showPassword)}
                  className="form__icon--left"
                />
              )}
            </div>
          </div>
        </div>

        <div className="form__group big-btm">
          <div className="row row--no-padding">
            <div className=" pos-rel">
              <input
                onChange={onchange2}
                value={text2}
                type={showPasswordConfirm ? "text" : "password"}
                className={`form__input has-icon has-left-icon circle ${
                  text2.length < 1 ? "" : text !== text2 ? "error" : "success"
                }`}
                placeholder={t("placeholders.confirm")}
              />
              <img
                src={`${process.env.PUBLIC_URL}/img/lock.svg`}
                alt="cobon back"
                className="form__icon"
              />
              {showPasswordConfirm ? (
                <img
                  src={`${process.env.PUBLIC_URL}/img/eye_2.svg`}
                  alt="cobon back"
                  onClick={() => setshowPasswordConfirm(!showPasswordConfirm)}
                  className="form__icon--left"
                />
              ) : (
                <img
                  src={`${process.env.PUBLIC_URL}/img/eye.svg`}
                  alt="cobon back"
                  onClick={() => setshowPasswordConfirm(!showPasswordConfirm)}
                  className="form__icon--left"
                />
              )}
            </div>
          </div>
        </div>

        <div className="form__group mg-top">
          <Link
            to="/phase2"
            className={` btn bold custom-padding ${
              (text === "" && text2 === "") || text !== text2
                ? "btn--disabled"
                : "btn--green"
            } w-100`}
          >
            {t("placeholders.send")}{" "}
          </Link>
        </div>
      </div>
    </div>
  );
}
